import {
	AIFeaturesModel,
	FoundryModelCapability,
} from "src/types/aiFeaturesConfiguration";
import { ApiAiFeaturesConfigurationService } from ".";
import {
	Controllers,
	AIFeaturesConfigurationApiRoutes,
} from "src/utils/constants";
import { HttpMethods } from "../httpMethods";
import { BaseService } from "../baseService";
import { AxiosResponse } from "axios";

export class AIFeaturesService
	extends BaseService
	implements ApiAiFeaturesConfigurationService
{
	getAIFeatures(): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.AIFeaturesConfiguration,
			""
		);
	}

	saveAIFeatures(data: AIFeaturesModel): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Post,
			Controllers.AIFeaturesConfiguration,
			"",
			null,
			data
		);
	}

	getAssistants(): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.AIFeaturesConfiguration,
			AIFeaturesConfigurationApiRoutes.Assistants
		);
	}

	getAgents(): Promise<any> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.AIFeaturesConfiguration,
			AIFeaturesConfigurationApiRoutes.Agents
		);
	}

	getModels(capability: FoundryModelCapability): Promise<any> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.AIFeaturesConfiguration,
			AIFeaturesConfigurationApiRoutes.Models,
			`?capability=${capability}`
		);
	}
}

export const aiFeaturesService = new AIFeaturesService();
